<template>
  <div class="my-pooq-content-body">
    <div class="mypooq-list"
         v-infinite-scroll="loadMore"
         :infinite-scroll-distance="200"
         :infinite-scroll-throttle-delay="200"
         v-if="device !== 'ios'">
      <div class="coin-table">
        <h4 class="mypooq-title">보유코인</h4>
        <table>
          <caption class="a11y-hidden">보유코인</caption>
          <colgroup>
            <col width="33.3333%">
            <col width="33.3333%">
            <col width="33.3333%">
          </colgroup>
          <thead>
          <tr>
            <th>총 코인</th>
            <th>충전 코인</th>
            <th>보너스 코인</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>{{propertyData.totalcoin | amount}}</td>
            <td>{{propertyData.chargedcoin | amount}}</td>
            <td>{{propertyData.bonuscoin | amount}}</td>
          </tr>
          </tbody>
        </table>
        <a href="#" class="coin-charge" @click.prevent="chargeCoinPopup">
          <span>코인 충전</span>
        </a>
      </div>
      <div class="select-box">
        <ul>
          <li :class="tabType === 'saving' ? 'on' : ''" @click.prevent="()=>changeTabType('saving')">적립 코인</li>
          <li :class="tabType === 'used' ? 'on' : ''" @click.prevent="()=>changeTabType('used')">소진 코인</li>
        </ul>
      </div>
      <my-pooq-empty-list v-if="showEmptyList"
                          :info-text="getEmptyText()"></my-pooq-empty-list>
      <ul class="coin-coupon-list">
        <li v-for="(coinInfo, index) in coinList" :key="tabType+'_'+index" :class="tabType === 'used' && coinInfo.expire==='y' ? 'expire' : ''">
            <span class="total-coin">
              <CoinIcon/>
                <span>
                  {{coinInfo.chargecoin | amount}}
                </span>
            </span>
          <span class="coin-coupon-info">
                <span class="coin-coupon-title">{{coinInfo.title}}</span>
                    <template v-if="tabType === 'saving'">
                        <span class="release-date" v-if="coinInfo.startdatetime">충전 <i class="icon-dotted"></i> {{coinInfo.startdatetime}}</span>
                        <span class="end-date" v-if="coinInfo.enddatetime">만료 <i class="icon-dotted"></i> {{coinInfo.enddatetime}}</span>
                        <span class="remain-coin" v-if="coinInfo.remaincoin">잔여 <i class="icon-dotted"></i> {{coinInfo.remaincoin | amount}}</span>
                        <span class="reason" v-if="coinInfo.description !== ''">지급 사유 <i class="icon-dotted"></i> {{coinInfo.description}}</span>
                   </template>
                   <template v-else-if="tabType === 'used'">
                        <span class="end-date" v-if="coinInfo.expire==='y'">만료 <i class="icon-dotted"></i> {{coinInfo.datetime}}</span>
                        <span class="end-date" v-else>사용 <i class="icon-dotted"></i> {{coinInfo.datetime}}</span>
                   </template>
            </span>
        </li>
      </ul>
    </div>
    <div class="mypooq-list" v-if="device === 'ios'">
      <my-pooq-empty-list info-text="코인 충전과 사용은<br>웨이브 홈페이지에서 이용 가능합니다."></my-pooq-empty-list>
    </div>
  </div>
</template>

<script>
import MyPooqEmptyList from '@/components/lnb/mypooq/MyPooqEmptyList'
import CoinIcon from '@/assets/svg/common/tag-coin-p.svg'
import { MyPooqService } from '@/common/api/api.service'
import { amount } from '@/common/filters'
import { infiniteScroll } from '@/common/directives'
import { get } from 'lodash'
import utils from '@/common/util/utils'
import { URL_ORIGIN } from '@/common/constant'
const TAB_TYPE_SAVING = 'saving'
const TAB_TYPE_USED = 'used'

export default {
  name: 'Coin',
  components: {
    CoinIcon,
    MyPooqEmptyList
  },
  directives: {
    infiniteScroll
  },
  filters: {
    amount
  },
  data () {
    return {
      propertyData: [],
      showEmptyList: false,
      dataList: undefined,
      tabType: 'saving',
      offset: 0,
      limit: 20,
      endOfList: false,
      coinList: [],
      isLoading: false,
      device: utils.cookies.getDevice()
    }
  },
  methods: {
    getEmptyText () {
      return `${this.tabType === TAB_TYPE_SAVING ? '적립' : '소진된'} 코인이 없어요.`
    },
    changeTabType (type) {
      this.tabType = type
    },
    chargeCoinPopup () {
      let locationOrigin = window.location.origin
      if (!locationOrigin) {
        locationOrigin = window.location.protocol + '//' + window.location.hostname
      }
      if (utils.cookies.getDevice() === 'android') {
        try {
          let url = encodeURIComponent(window.location.origin +
            '/callback.html?action=ClosePopupAndReload')
          window.Android.clickChargeCoin(url)
        } catch (err) {
          console.log(err)
        }
      } else {
//        utils.common.showCoinPopup(false, locationOrigin + '/callback.html?action=ClosePopupAndReload')
        utils.common.showCoinPopup(false, URL_ORIGIN + '/callback.html?action=ClosePopupAndReload')
      }
    },
    loadMore () {
      if (this.endOfList) return
      this.setData()
    },
    setData () {
      if (this.isLoading) return
      this.isLoading = true
      let api = null
      if (this.tabType === TAB_TYPE_SAVING) {
        api = MyPooqService.getMyCoinListCharged({
          offset: this.offset,
          limit: this.limit,
          orderby: 'new'
        })
      } else if (this.tabType === TAB_TYPE_USED) {
        api = MyPooqService.getMyCoinListExpired({
          offset: this.offset,
          limit: this.limit,
          orderby: 'new'
        })
      }
      api.then(({ data }) => {
        let resList = get(data, 'list', [])
        this.endOfList = resList.length === 0
        this.showEmptyList = this.coinList.length === 0 && resList.length === 0
        this.offset += this.limit
        this.coinList = this.coinList.concat(resList)
        this.isLoading = false
      })
    }
  },
  created () {
    MyPooqService.getMyCoinSummary().then(({ data }) => {
      this.propertyData = data
    })
  },
  watch: {
    tabType () {
      this.coinList = []
      this.showEmptyList = false
      this.endOfList = false
      this.offset = 0
      this.$nextTick(() => {
        this.setData()
      })
    }
  }
}
</script>

<style scoped>

</style>
